import React, { useState } from "react";
import { Col, Container, Row, Collapse } from "react-bootstrap";
import { MultiSelect } from "react-multi-select-component";
import Checkbox from "@mui/material/Checkbox";
import Button from "@restart/ui/esm/Button";
import { Card, Image } from "react-bootstrap";
import ForCompFace from "../assets/images/ForCompFace.png";
import forCompLoc from "../assets/images/forCompLoc.png";
import { useHistory } from "react-router";
const options = [
  { label: "Grapes ", value: "grapes", id: 1 },
  { label: "Mango ", value: "mango", id: 2 },
  { label: "Strawberry ", value: "strawberry", disabled: true, id: 3 },
];

const CraftmenJobs = ({ setfooterStyle }) => {
  const history = useHistory();

  history.location.pathname ? setfooterStyle(true) : setfooterStyle(false);
  const [openCountry, setOpenCountry] = useState(true);
  const [openSkills, setOpenSkills] = useState(true);
  const [openExperience, setOpenExperience] = useState(true);
  const [checked, setChecked] = React.useState({
    drivingLicense: false,
    fresh: false,
    oneToTwoYear: false,
    twoToFourYear: false,
    fourToSixYear: false,
    sixToEightYear: false,
    eightToTenYear: false,
    tenYearPlus: false,
  });
  console.log("this is checked ", checked);
  const [selected, setSelected] = useState([]);
  const handleDelete = (i) => {
    console.log(i);
    const updated = selected.filter((item, index) => {
      return item.id !== i;
    });
    setSelected(updated);
  };
  const handleChange = (event) => {
    const { name } = event.target;
    setChecked({ ...checked, [event.target.name]: event.target.checked });
  };
  const count = new Array(12).fill("");

  return (
    <div>
      <div className="allJobs_banner">
        <Container>
          <Row>
            <Col>
              <h2 className="whito">
                <span className="regular">Search for a job </span> The Job You
                Are <br />
                Looking For
              </h2>
              <div className="searchField_main">
                <input
                  placeholder="Search..."
                  className="searchField_allJobs"
                />
                <i class="fas fa-search"></i>
              </div>
            </Col>
          </Row>
        </Container>
      </div>

      <Container>
        <Row>
          <Col md={2}>
            <div className="craftmen_filter_main filter_main">
              <h5 className="border_filter">Filters</h5>

              <div className="dropdown_main carftmein_country">
                <div className="d-flex carftmein_country">
                  <h6>Country</h6>

                  <i
                    onClick={() => setOpenCountry(!openCountry)}
                    aria-controls="example-collapse-text"
                    aria-expanded={openCountry}
                    class={openCountry ? "fas fa-minus" : "fas fa-plus"}
                  ></i>
                </div>

                <Collapse in={openCountry}>
                  <div id="example-collapse-text">
                    <div className="">
                      <div style={{ marginBottom: 10 }}>
                        <MultiSelect
                          options={options}
                          value={selected}
                          onChange={setSelected}
                        />
                        {selected.map((item, i) => {
                          return (
                            <>
                              <div key={item.id}>
                                {item.label}
                                <button onClick={() => handleDelete(item.id)}>
                                  cancel
                                </button>
                              </div>
                            </>
                          );
                        })}
                      </div>
                    </div>
                  </div>
                </Collapse>
              </div>
              <div className="dropdown_main carftmein_skills">
                <div className="d-flex carftmein_skills">
                  <h6>Skills</h6>

                  <i
                    onClick={() => setOpenSkills(!openSkills)}
                    aria-controls="example-collapse-text"
                    aria-expanded={openSkills}
                    class={openSkills ? "fas fa-minus" : "fas fa-plus"}
                  ></i>
                </div>

                <Collapse in={openSkills}>
                  <div id="example-collapse-text">
                    <div className="">
                      <Checkbox
                        checked={checked.drivingLicense}
                        name="drivingLicense"
                        onChange={handleChange}
                        inputProps={{ "aria-label": "controlled" }}
                      />
                      black smith
                    </div>
                    <div className="">
                      <Checkbox
                        checked={checked.drivingLicense}
                        name="drivingLicense"
                        onChange={handleChange}
                        inputProps={{ "aria-label": "controlled" }}
                      />
                      welder
                    </div>
                    <div className="">
                      <Checkbox
                        checked={checked.drivingLicense}
                        name="drivingLicense"
                        onChange={handleChange}
                        inputProps={{ "aria-label": "controlled" }}
                      />
                      carpenter
                    </div>
                    <div className="">
                      <Checkbox
                        checked={checked.drivingLicense}
                        name="drivingLicense"
                        onChange={handleChange}
                        inputProps={{ "aria-label": "controlled" }}
                      />
                      black smith
                    </div>
                    <div className="">
                      <Checkbox
                        checked={checked.drivingLicense}
                        name="drivingLicense"
                        onChange={handleChange}
                        inputProps={{ "aria-label": "controlled" }}
                      />
                      welder
                    </div>
                    <div className="">
                      <Checkbox
                        checked={checked.drivingLicense}
                        name="drivingLicense"
                        onChange={handleChange}
                        inputProps={{ "aria-label": "controlled" }}
                      />
                      carpenter
                    </div>
                  </div>
                </Collapse>
              </div>
              <div className="dropdown_main carftmein_skills">
                <div className="d-flex carftmein_skills">
                  <h6>Certificates</h6>

                  <i
                    onClick={() => setOpenSkills(!openSkills)}
                    aria-controls="example-collapse-text"
                    aria-expanded={openSkills}
                    class={openSkills ? "fas fa-minus" : "fas fa-plus"}
                  ></i>
                </div>

                <Collapse in={openSkills}>
                  <div id="example-collapse-text">
                    <div className="">
                      <Checkbox
                        checked={checked.drivingLicense}
                        name="drivingLicense"
                        onChange={handleChange}
                        inputProps={{ "aria-label": "controlled" }}
                      />
                      DS / EN_ISO9606-1
                    </div>
                    <div className="">
                      <Checkbox
                        checked={checked.drivingLicense}
                        name="drivingLicense"
                        onChange={handleChange}
                        inputProps={{ "aria-label": "controlled" }}
                      />
                      Driving license_B
                    </div>
                    <div className="">
                      <Checkbox
                        checked={checked.drivingLicense}
                        name="drivingLicense"
                        onChange={handleChange}
                        inputProps={{ "aria-label": "controlled" }}
                      />
                      DS / EN_ISO9606_2
                    </div>
                    <div className="">
                      <Checkbox
                        checked={checked.drivingLicense}
                        name="drivingLicense"
                        onChange={handleChange}
                        inputProps={{ "aria-label": "controlled" }}
                      />
                      Driving license_DE
                    </div>
                 
                  </div>
                </Collapse>
              </div>
              <div className="dropdown_main carftmein_experience">
                <div className="d-flex carftmein_experience">
                  <h6>Experience</h6>

                  <i
                    onClick={() => setOpenExperience(!openExperience)}
                    aria-controls="example-collapse-text"
                    aria-expanded={openExperience}
                    class={openExperience ? "fas fa-minus" : "fas fa-plus"}
                  ></i>
                </div>

                <Collapse in={openExperience}>
                  <div id="example-collapse-text">
                    <div className="">
                      <Checkbox
                        checked={checked.fresh}
                        name="fresh"
                        onChange={handleChange}
                        inputProps={{ "aria-label": "controlled" }}
                      />
                      Fresh
                    </div>
                    <div className="">
                      <Checkbox
                        checked={checked.oneToTwoYear}
                        name="oneToTwoYear"
                        onChange={handleChange}
                        inputProps={{ "aria-label": "controlled" }}
                      />
                      1 - 2 Years
                    </div>
                    <div className="">
                      <Checkbox
                        checked={checked.twoToFourYear}
                        name="twoToFourYear"
                        onChange={handleChange}
                        inputProps={{ "aria-label": "controlled" }}
                      />
                      2 - 4 Years
                    </div>
                    <div className="">
                      <Checkbox
                        checked={checked.fourToSixYear}
                        name="fourToSixYear"
                        onChange={handleChange}
                        inputProps={{ "aria-label": "controlled" }}
                      />
                      4 - 6 Years
                    </div>
                    <div className="">
                      <Checkbox
                        checked={checked.sixToEightYear}
                        name="sixToEightYear"
                        onChange={handleChange}
                        inputProps={{ "aria-label": "controlled" }}
                      />
                      6 - 8 Years
                    </div>
                    <div className="">
                      <Checkbox
                        checked={checked.eightToTenYear}
                        name="eightToTenYear"
                        onChange={handleChange}
                        inputProps={{ "aria-label": "controlled" }}
                      />
                      8 - 10 Years
                    </div>
                    <div className="">
                      <Checkbox
                        checked={checked.tenYearPlus}
                        name="tenYearPlus"
                        onChange={handleChange}
                        inputProps={{ "aria-label": "controlled" }}
                      />
                      10 Years +
                    </div>
                  </div>
                </Collapse>
              </div>
            </div>
          </Col>
          <Col md={10}>
            <Row>
              <h2>
                <span className="regular">Craftmen </span> Profiles
              </h2>
              {count.map((item, i) => (
                <Col>
                  <Card className="for_comp_main text-center">
                    <Card.Img className="for_comp_main_img" src={ForCompFace} />
                    <Card.Body>
                      <Card.Title className="text-center regular">
                        Person Name
                      </Card.Title>
                      <Card.Text>Professional Designation</Card.Text>
                      <Card.Text>
                        <div>
                          <Image src={forCompLoc} /> Location
                        </div>
                      </Card.Text>

                      <div className="for_comp_tags">
                        <h6>Skill 01</h6>
                        <h6>Skill 01</h6>
                        <h6>Skill 01</h6>
                      </div>
                      <div className="for_comp_tags second">
                        <h6>Skill 01</h6>
                        <h6>Skill 01</h6>
                      </div>
                    </Card.Body>
                  </Card>
                </Col>
              ))}
            </Row>
          </Col>
        </Row>
      </Container>
    </div>
  );
};

export default CraftmenJobs;
